export class ReachUs {
    Name:string;
    Email:string;
    PhoneNo:string;
    Subject:string;
    Message:string;
    Captcha:string='';
}
